import './App.css';
import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './components/pages/Home';
import Admin from './components/pages/Admin';
import AddItems from './components/pages/AddItems';
import Cashier from './components/pages/Cashier';
import EposNavbar from './components/layout/EposNavbar';
import Sampleproducts from './components/SampleProducts';




function App() {

  const [products, setProducts] = useState(
    localStorage.getItem("products") ? JSON.parse(localStorage.getItem("products")) : {Sampleproducts}.Sampleproducts.products.products
    );
  useEffect(() => {
    setLocalStorage();
  })

  const setLocalStorage = () => {
    if (!localStorage.getItem("products")){
      localStorage.setItem("products",JSON.stringify(products));
    };
  
  };
  const addToLocalStorage = (newItem) => {
    var existingProducts = JSON.parse(localStorage.getItem("products"));
    var duplicate = false;
    var updateIndex = 0;
    console.log(newItem);
    console.log(existingProducts);

    if (existingProducts.some(e => e.barcode === newItem.barcode)) {
        duplicate = true;
        updateIndex = existingProducts.findIndex(item => item.barcode === newItem.barcode);
      }

      if(duplicate){
        existingProducts[updateIndex].name = newItem.name;
        existingProducts[updateIndex].purchase_price = newItem.purchase_price;
        existingProducts[updateIndex].sale_price = newItem.sale_price;
        existingProducts[updateIndex].qty = newItem.qty;

      }
      else {
        existingProducts.push(newItem);
      }
    
    // if (existingProducts.some(e => e.barcode === newItem.barcode)) {
    //   duplicate = true;
    // }
    // else {
    //   duplicate = false;
    // }
    // if(duplicate){
    //   console.log(duplicate);
    // }
    // else {
    //   existingProducts.push(newItem);
    // }
    
    
    //existingProducts.push(newItem);
    localStorage.setItem("products", JSON.stringify(existingProducts));
    setProducts(products => existingProducts);
  };
   const addItemsOnClick = (newItem) => {
   setProducts(products =>[...products,newItem]);
   addToLocalStorage(newItem);
    
    // setProducts({
    //   products : 1
    // });
  }
 const removeItem = (barcode) => {
    console.log("blah");
 }

 const handleRemoveClick = (event) => {
  var clickedNode = null;
  event.target.innerHTML === "" ? clickedNode = event.target.parentNode.parentNode.parentNode.parentNode : clickedNode = event.target.parentNode.parentNode.parentNode;
  var itemsFromStorage = JSON.parse(localStorage.getItem("products"));
  var updatedItemsForStorage = itemsFromStorage.filter(product => product.barcode !== clickedNode.id);
  localStorage.setItem("products",JSON.stringify(updatedItemsForStorage));
  setProducts(products => updatedItemsForStorage);
 }
 

  return (
    <Router>
    <div className="App">
      <EposNavbar />
      
        <Routes>
          <Route path ="/" exact={true} element={<Home products={products} />} />
          <Route path ="/admin" exact={true} element={<Admin />} />
          <Route path ="/add-items" exact={true} element={<AddItems 
                                                            products={products} 
                                                            addItemsOnClick={addItemsOnClick} 
                                                            handleRemoveClick={handleRemoveClick}
                                                            />} 
                                                            />
          <Route path ="/cashier" exact={true} element={<Cashier 
                                                            products={products}
                                                            />} />
        </Routes>
      
    </div>
    </Router>
  );
}

export default App;